export default __webpack_public_path__ + "static/media/art-5-main-sm.9b2ca41a.jpg";